import React from 'react';
import { createRoot } from 'react-dom/client'; // <-- Add this import
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container); // <-- Use createRoot directly

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);